import * as React from "react";
import { BarChart } from '@mui/x-charts';
import { Box, Tab, Tabs } from "@mui/material";

const TabbedBarChart = ({ chart_data, isFullWidth, layout }) => {

    const [tab, setTab] = React.useState('daily');

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    const getChartData = () => {
        const data = tab === 'daily' ? daily : weekly;

        const xData = tab === 'daily'
            ? daily?.map((d) => d?.xAxis)
            : weekly?.map((d) => d?.xAxis);

        const yData = tab === 'daily'
            ? daily?.map((d) => d?.yAxis)
            : weekly?.map((d) => d?.yAxis);

        return { xData, yData };
    };

    const { xData, yData } = getChartData();

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data.title}</h3>
            <p>{chart_data.description}</p>

            <Tabs value={tab} onChange={handleChange}
                sx={{
                    mb: 2,
                    borderRadius: 2,
                    '& .MuiTab-root': {
                        fontSize: '12px',
                        color: '#555',
                        textTransform: 'none',
                        fontWeight: 100,
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        marginRight: '12px',
                        height: '20px',
                        width: '80px',
                        minWidth: 'unset',
                    },
                    '& .Mui-selected': {
                        color: '#ffffff !important',
                        backgroundColor: '#1976d2',
                        borderRadius: '8px',
                    },
                    '& .MuiTabs-indicator': {
                        display: 'none', // remove default indicator
                    },
                }}
            >
                <Tab label="Daily" value="daily" />
                <Tab label="Weekly" value="weekly" />
            </Tabs>

            <BarChart
                xAxis={[{ id: xAxis, data: xData, scaleType: 'band',label:chart_data?.xAxis }]}
                series={[{ data: yData,label:chart_data?.yAxis }]}
                height={300}
            />
        </div>
    );

}

const styles ={
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
      },
      cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
      },
};

export default TabbedBarChart;